import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=4683f920&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "./feedback.vue?vue&type=style&index=0&id=4683f920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4683f920",
  null
  
)

export default component.exports